export class IMemberFeeDetails {
    _id: string;
    invoice: string;
    fee: number;
    pay: number;
    remainingBalance: number;
    tax: number;
    status: string;
    date: Date;
    createdDate: Date;
    month: number;
    day: string;
    year: number;
    memberId: string;
    description: string;
    dueDate: Date;
    nextDueDate: Date;
    feeReceiptImageUrl: string;
    transactionNumber: string;
    paymentMode: string;
    isDelete: boolean;
    isDefaulter: boolean;
    isSynced: boolean;
    type: string;
    scope: string;
    currentUserData: any;
    initiatedFrom: any;
    oldDate: any;
    discountAmount:number;
    discount:number;
    createdBy: string;
    enteredBy: string;
    remainingSessionCount: number;
    sessionCount: string;
    dayPass : String;
    trainerName: string;
    taxRate: number;
    taxCalculationType: string;
    noOfMonths : number;
    name : string;
    tagNumber: any;
    packageName: string;
    dueDateAfterApproval: Date;
    isApproved: boolean;
    months: Array<any> = [];
    numberOfVisitors: number;
}
